import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import { SUPPORT_URL } from "../appPublicUrls";

export default function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title="Privacy Policy">
      <p style={{ marginTop: 0 }}>
        <strong>Quizmaster Bob Player</strong> (the mobile app) and the Quizmaster Bob host
        website work together for live pub trivia. This policy describes data handled when you
        use the <strong>player app</strong> or join a game as a player in the browser.
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>What we collect</h2>
      <ul>
        <li>
          <strong>Game participation:</strong> team name, answers, scores, and progress stored in
          our cloud database (Google Firebase) for the quiz you joined.
        </li>
        <li>
          <strong>Team selfie (optional):</strong> if you take or choose a photo, it is uploaded
          to secure cloud storage and may be shown on the host&apos;s venue screen.
        </li>
        <li>
          <strong>Device storage:</strong> the app may save your team name and game code locally so
          you can reconnect to the same quiz.
        </li>
      </ul>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>What we do not collect in the player app</h2>
      <p>
        The player app does not require an account, email, or payment. Hosts who run quizzes use a
        separate login on the website; that flow is covered by host account terms, not this page.
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Why we use data</h2>
      <p>
        Data is used only to run the quiz you joined: validating join codes, recording answers,
        showing leaderboards, and letting your team reconnect if the app closes.
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Sharing</h2>
      <p>
        Quiz data is visible to the quiz host and other teams only as part of normal gameplay (e.g.
        scores on the big screen). We do not sell personal information. Infrastructure is provided
        by Google Firebase (hosting, database, storage) under their terms.
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Retention</h2>
      <p>
        Game and team data remain in the database while the host&apos;s quiz session is active and
        as needed for host operations. You can clear local reconnect data in the app by starting a
        new game.
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Children</h2>
      <p>
        The app is intended for venue trivia with host supervision. Hosts are responsible for
        appropriate use at their event.
      </p>

      <h2 style={{ fontSize: "1.15rem", marginTop: 24 }}>Contact</h2>
      <p>
        Questions about privacy: see our{" "}
        <a href={SUPPORT_URL} style={{ color: "#99ffc9" }}>
          support page
        </a>
        .
      </p>

      <p style={{ fontSize: "0.85rem", opacity: 0.85, marginTop: 24 }}>
        Last updated: May 2026
      </p>
    </LegalPageLayout>
  );
}
